"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = void 0;
/**
 * Defines a set of states some user can be in. The Frontend e.g. decides
 * the view it should show when a user logs in based on this information.
 */
// eslint-disable-next-line import/prefer-default-export
var UserStatus;
(function (UserStatus) {
    UserStatus["Banned"] = "banned";
    UserStatus["Cooldown"] = "cooldown";
    UserStatus["Parking"] = "parking";
    UserStatus["Idle"] = "idle";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
//# sourceMappingURL=user.js.map